import { Component } from 'react';
import IbssChip from '../../../../Components/Navigation/Chip/IbssChip';
import { List, Typography } from '@mui/material';

class DeviceChips extends Component<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    }

    public render(): JSX.Element
    {
        return (
            <List sx={{display: 'flex', flexWrap: 'wrap', gap: '1rem'}}>
                {this.props.deviceIds.map(id => 
                    <IbssChip
                        key={id}
                        label={<Typography sx={{fontFamily: 'Source Sans Pro', fontWeight:'bold'}}>{id}</Typography>} 
                        onDelete={()=> this.props.onDelete(id)}
                        sx={{height: '40px', width: 'auto'}}
                        variant={'filled'}
                    />
                )}
            </List>
        )
    }
}

export default DeviceChips;

export interface IProps
{
    deviceIds: string[];
    onDelete: (item: string) => void;
}

export interface IState
{
}